export {};
//# sourceMappingURL=wrap-audio-buffer-copy-channel-methods-out-of-bounds-function.js.map